import { Dayjs } from "dayjs";

interface DateRangeResult {
    start: Dayjs | null;
    end: Dayjs | null;
    flipped?: boolean;
}
export { DateRangeResult };
